import columns from '../../../../react-table/helpers/columns';
import { sumRoundedTotal, sumTotalConditional, totalRowRatioConditional }
  from '../../../../react-table/helpers/rowTotals';

export const getPaperFreeRows = data =>
  data.filter(row => row.paperFree === 'Y');

export const getAllRows = data => data;

export default (data) => {
  const {
    NonZeroNumberColumn,
    NonZeroPercentageColumn,
  } = columns(data);
  return [
    {
      columns: [
        new NonZeroNumberColumn('Total volume', 'volume').withTotalHeader(sumRoundedTotal),
        new NonZeroNumberColumn('Paper free volume', 'volume').withTotalHeader(sumTotalConditional(getPaperFreeRows)),
        new NonZeroPercentageColumn('Paper free %', 'paperFree').withTotalHeader(totalRowRatioConditional([
          { id: 'volume', filter: getPaperFreeRows },
          { id: 'volume', filter: getAllRows },
        ])),
      ],
    },
  ];
};
